import { AgGrid } from "@jsq/ds/core";

/**
 * List of the supported columns in the Payee table
 * (ordered from left to right)
 */
export enum SupportedColumns {
  Payee = "payeeName",
  Client = "clientName",
  Type = "payeeType",
  ReceivingAccount = "receivingAccount",
  PaymentMethod = "paymentMethod",
  ApprovalStatus = "status",
}

/**
 * The mapper provides the corresponding column name displayed in the table
 */
export const columnNames = new Map<SupportedColumns, string>([
  [SupportedColumns.Payee, "Payee"],
  [SupportedColumns.Client, "Client"],
  [SupportedColumns.Type, "Type"],
  [SupportedColumns.ReceivingAccount, "Receiving account"],
  [SupportedColumns.PaymentMethod, "Payment method"],
  [SupportedColumns.ApprovalStatus, "Approval status"],
]);

/**
 * AG Grid Column definitions for the Payee Table
 */
export const columnDefinitions: AgGrid.ColDef[] = [
  {
    field: SupportedColumns.Payee,
    headerName: columnNames.get(SupportedColumns.Payee),
    pinned: "left",
    minWidth: 360,
  },
  {
    field: SupportedColumns.Client,
    headerName: columnNames.get(SupportedColumns.Client),
  },
  {
    field: SupportedColumns.Type,
    headerName: columnNames.get(SupportedColumns.Type),
  },
  {
    field: SupportedColumns.ReceivingAccount,
    headerName: columnNames.get(SupportedColumns.ReceivingAccount),
  },
  {
    field: SupportedColumns.PaymentMethod,
    headerName: columnNames.get(SupportedColumns.PaymentMethod),
  },
  {
    field: SupportedColumns.ApprovalStatus,
    headerName: columnNames.get(SupportedColumns.ApprovalStatus),
  },
];
